<template>
  <div>
    <div v-if="showIntro" class="text-container md:md-text-container">
      <div class="grid grid-cols-1 md:grid-cols-10 gap-5">
        <div class="md:col-span-8">
          <Heading text="A Psyche-Selfie of your Happy Place"/>
        </div>
        <div class="md:col-span-8">
          We’re now going to use artificial intelligence to transform your chosen icons
          into a series of symbolic snapshots.
        </div>
        <div class="md:col-span-8">
          There will be several stages.  At each stage choose the one you feel best represents your
        </div>
        <div class="md:col-span-8 theme">
          Happy Place
        </div>
        <div class="md:col-span-8">
          <Button v-bind:onClick="endIntro" text="Continue"/>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="memes-container">
        <div class="grid grid-cols-11 memes md:md-memes">
          <div class="col-span-5 meme-container">
            <div
              v-if="currentMemeSet"
              v-on:click="if (canSelect){selectMeme(currentMemeSet.memes[0].id)}"
              class="meme-container"
            >
              <img class="meme-image" :src="currentMemeSet.memes[0].image"/>
            </div>
          </div>
          <div class="col-span-1">
            <div class="vertical-separator"/>
          </div>
          <div class="col-span-5 meme-container">
            <div
              v-if="currentMemeSet"
              v-on:click="if (canSelect){selectMeme(currentMemeSet.memes[1].id)}"
              class="meme-container"
            >
              <img class="meme-image" :src="currentMemeSet.memes[1].image"/>
            </div>
          </div>
          <div class="col-span-5">
            <div class="horizontal-separator md:md-horizontal-separator"/>
          </div>
          <div class="col-span-5 col-start-7">
            <div class="horizontal-separator md:md-horizontal-separator"/>
          </div>
          <div class="col-span-5 meme-container">
            <div
              v-if="currentMemeSet"
              v-on:click="if (canSelect){selectMeme(currentMemeSet.memes[2].id)}"
              class="meme-container"
            >
              <img class="meme-image" :src="currentMemeSet.memes[2].image"/>
            </div>
          </div>
          <div class="col-span-1">
            <div class="vertical-separator"/>
          </div>
          <div class="col-span-5 meme-container">
            <div
              v-if="currentMemeSet"
              v-on:click="if (canSelect){selectMeme(currentMemeSet.memes[3].id)}"
              class="meme-container"
            >
              <img class="meme-image" :src="currentMemeSet.memes[3].image"/>
            </div>
          </div>
          <div class="col-span-11">
            <Progress
              :current=progress
              :total=18
            />
          </div>
        </div>
      </div>
      <div v-if="!currentMemeSet || hasFinished" class="arc md:md-arc"/>
    </div>
    <audio ref="aud" src="@/assets/audio/meme-select.mp3" />
  </div>
</template>

<script>
import axios from 'axios';
import Button from '@/components/Button.vue';
import Heading from '@/components/Heading.vue';
import Progress from '@/components/Progress.vue';

export default {
  name: 'MemeSelect',
  components: {
    Button,
    Heading,
    Progress,
  },
  data() {
    return {
      currentMemeSet: null,
      showIntro: true,
      previousMemeSets: 0,
      canSelect: false,
      progress: 1,
      getNextMemeSetAttempts: 0,
      selectMemeAttempts: 0,
      setFinalMemeAttempts: 0,
      hasFinished: false,
    };
  },
  methods: {
    endIntro() {
      this.showIntro = false;
      this.$refs.aud.pause();
    },
    getNextMemeSet() {
      this.getNextMemeSetAttempts += 1;

      let endpoint;

      if (this.previousMemeSets <= 9) {
        endpoint = 'get-icon-memes/';
      } else {
        endpoint = 'get-color-memes/';
      }

      axios
        .get(`${process.env.VUE_APP_BACKEND_URL}/api/sessions/${endpoint}?session=${this.$store.state.sessionId}`)
        .then((response) => {
          this.getNextMemeSetAttempts = 0;
          this.currentMemeSet = response.data;
          this.currentMemeSet.displayTime = Date.now();
          this.canSelect = true;
        })
        .catch((error) => {
          if (this.getNextMemeSetAttempts < 3) {
            setTimeout(this.getNextMemeSet, 2000);
          } else {
            this.$store.commit('setErrorMessage', error);
          }
        });
    },
    selectMeme(memeId) {
      this.selectMemeAttempts += 1;

      if (this.progress < 18) {
        this.progress += 1;
      }

      this.canSelect = false;
      let endpoint;

      if (this.previousMemeSets <= 9) {
        endpoint = 'submit-icon-meme/';
      } else {
        endpoint = 'submit-color-meme/';
      }

      axios
        .post(
          `${process.env.VUE_APP_BACKEND_URL}/api/sessions/${endpoint}`,
          {
            uuid: this.$store.state.sessionId,
            meme_set: this.currentMemeSet.set_id,
            selected_meme: memeId,
            time_to_select: Date.now() - this.currentMemeSet.displayTime,
          },
        )
        .then(() => {
          this.selectMemeAttempts = 0;

          if (this.previousMemeSets < 17) {
            this.previousMemeSets += 1;
            this.currentMemeSet = null;
            this.getNextMemeSet();
          } else {
            this.setFinalMeme();
          }
        })
        .catch((error) => {
          if (this.selectMemeAttempts < 3) {
            setTimeout(() => { this.getNextMemeSet(memeId); }, 2000);
          } else {
            this.$store.commit('setErrorMessage', error);
          }
        });
    },
    setFinalMeme() {
      this.setFinalMemeAttempts += 1;
      this.hasFinished = true;

      const url = `${process.env.VUE_APP_BACKEND_URL}/api/sessions/get-final-meme/?session=${this.$store.state.sessionId}`;

      axios
        .get(url)
        .then((response) => {
          this.$store.commit('setFinalMeme', response.data);
          this.$store.commit('setView', 'Congratulations');
        })
        .catch((error) => {
          if (this.setFinalMemeAttempts < 3) {
            setTimeout(this.setFinalMeme, 2000);
          } else {
            this.$store.commit('setErrorMessage', error);
          }
        });
    },
  },
  mounted() {
    this.getNextMemeSet();
    this.$refs.aud.play();
  },
};
</script>

<style scoped>
.arc {
  animation: rotate 2s infinite linear;
  border: 1px solid #c2c1c1;
  border-radius: 50%;
  border-top-color: transparent;
  height: 5vw;
  left: calc(50vw - 2.5vw);
  margin: auto;
  position: absolute;
  top: calc(50vh - 2.5vw);
  width: 5vw;
}

.content {
  align-self: center;
  width: 100%
}

.horizontal-separator {
  background-color: #c2c1c1;;
  height: 2px;
  margin: 4.5vw 0;
  width: 45vw;
}

.meme-bottom {
  align-content: center;
}

.meme-container {
  align-items: center;
  display: flex;
  justify-content: center;
}

.meme-image {
  width: 95%;
}

.meme-left {
  align-content: left;
}

.meme-right {
  align-content: right;
}

.meme-top {
  align-content: center;
}

.memes-container {
  display: flex;
  height: 100vh;
}

.meme-image {
  width: 90%;
}

.memes {
  margin: auto;
}

.theme {
  color: #9a9899;
  font-size: 2em;
}

.vertical-separator {
  background-color: #c2c1c1;;
  height: 25vw;
  margin: auto;
  max-height: 40vh;
  width: 2px;
}

@keyframes rotate {
  0%    { transform: rotate(0deg);  }
  100%  { transform: rotate(360deg);  }
}

@responsive {
  .md-arc {
    border-width: 2px;
    height: 50px;
    left: calc(50vw - 25px);
    top: calc(50vh - 25px);
    width: 50px;
  }

  .md-intro-container {
    margin-top: 8vh;
    max-width: 70vw;
    text-align: left;
  }

  .md-horizontal-separator {
    margin: 3vw 0;
    width: 100%;
  }

  .md-memes {
    width: 66vw;
  }

  .md-text {
    font-size: 2em;
  }
}
</style>
